/* tslint:disable */
import {
  TemplateHeader
} from '../index';

declare var Object: any;
export interface ChangeSOPConfiguratorHeaderInterface {
  "sfdcId"?: string;
  "Name"?: string;
  "CurrencyIsoCode"?: string;
  "CreatedById"?: string;
  "LastModifiedById"?: string;
  "CreatedBy__c"?: string;
  "LastModifiedBy__c"?: string;
  "Approval_Stage__c"?: string;
  "Approval_Status__c"?: string;
  "Business_Unit__c"?: string;
  "Change_SOP_Header_Number__c"?: string;
  "Configurator_Header_No__c"?: string;
  "Created_By__c"?: string;
  "Default__c"?: boolean;
  "Description__c"?: string;
  "Lastmodifed_By__c"?: string;
  "PgMO_Departments__c"?: string;
  "PgMO_Groups__c"?: string;
  "Region__c"?: string;
  "Serviceo_Problem_Reason_Codes__c"?: string;
  "Solution_Name_Description__c"?: string;
  "Type__c"?: string;
  "id"?: number;
  "PgMO_Template_Header__c"?: string;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  templateHeader?: TemplateHeader;
}

export class ChangeSOPConfiguratorHeader implements ChangeSOPConfiguratorHeaderInterface {
  "sfdcId": string;
  "Name": string;
  "CurrencyIsoCode": string;
  "CreatedById": string;
  "LastModifiedById": string;
  "CreatedBy__c": string;
  "LastModifiedBy__c": string;
  "Approval_Stage__c": string;
  "Approval_Status__c": string;
  "Business_Unit__c": string;
  "Change_SOP_Header_Number__c": string;
  "Configurator_Header_No__c": string;
  "Created_By__c": string;
  "Default__c": boolean;
  "Description__c": string;
  "Lastmodifed_By__c": string;
  "PgMO_Departments__c": string;
  "PgMO_Groups__c": string;
  "Region__c": string;
  "Serviceo_Problem_Reason_Codes__c": string;
  "Solution_Name_Description__c": string;
  "Type__c": string;
  "id": number;
  "PgMO_Template_Header__c": string;
  "createdAt": Date;
  "updatedAt": Date;
  templateHeader: TemplateHeader;
  constructor(data?: ChangeSOPConfiguratorHeaderInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ChangeSOPConfiguratorHeader`.
   */
  public static getModelName() {
    return "ChangeSOPConfiguratorHeader";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ChangeSOPConfiguratorHeader for dynamic purposes.
  **/
  public static factory(data: ChangeSOPConfiguratorHeaderInterface): ChangeSOPConfiguratorHeader{
    return new ChangeSOPConfiguratorHeader(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ChangeSOPConfiguratorHeader',
      plural: 'ChangeSOPConfiguratorHeaders',
      path: 'ChangeSOPConfiguratorHeaders',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "CreatedBy__c": {
          name: 'CreatedBy__c',
          type: 'string'
        },
        "LastModifiedBy__c": {
          name: 'LastModifiedBy__c',
          type: 'string'
        },
        "Approval_Stage__c": {
          name: 'Approval_Stage__c',
          type: 'string'
        },
        "Approval_Status__c": {
          name: 'Approval_Status__c',
          type: 'string'
        },
        "Business_Unit__c": {
          name: 'Business_Unit__c',
          type: 'string'
        },
        "Change_SOP_Header_Number__c": {
          name: 'Change_SOP_Header_Number__c',
          type: 'string'
        },
        "Configurator_Header_No__c": {
          name: 'Configurator_Header_No__c',
          type: 'string'
        },
        "Created_By__c": {
          name: 'Created_By__c',
          type: 'string'
        },
        "Default__c": {
          name: 'Default__c',
          type: 'boolean'
        },
        "Description__c": {
          name: 'Description__c',
          type: 'string'
        },
        "Lastmodifed_By__c": {
          name: 'Lastmodifed_By__c',
          type: 'string'
        },
        "PgMO_Departments__c": {
          name: 'PgMO_Departments__c',
          type: 'string'
        },
        "PgMO_Groups__c": {
          name: 'PgMO_Groups__c',
          type: 'string'
        },
        "Region__c": {
          name: 'Region__c',
          type: 'string'
        },
        "Serviceo_Problem_Reason_Codes__c": {
          name: 'Serviceo_Problem_Reason_Codes__c',
          type: 'string'
        },
        "Solution_Name_Description__c": {
          name: 'Solution_Name_Description__c',
          type: 'string'
        },
        "Type__c": {
          name: 'Type__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "PgMO_Template_Header__c": {
          name: 'PgMO_Template_Header__c',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        templateHeader: {
          name: 'templateHeader',
          type: 'TemplateHeader',
          model: 'TemplateHeader',
          relationType: 'belongsTo',
                  keyFrom: 'PgMO_Template_Header__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
